import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=00fedb07&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00fedb07')) {
      api.createRecord('00fedb07', component.options)
    } else {
      api.reload('00fedb07', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=00fedb07&", function () {
      api.rerender('00fedb07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22J9akXhfqEUQ/JS/comp/openstreetmap.vue"
export default component.exports